import gql from 'graphql-tag'

export const GET_VIDEOS_BY_COURSE_SLUG = gql`
  query academyCourse($slug: String!) {
    academyCourse(slug: $slug) {
      id
      courseMedias {
        id
        media {
          thumbnail
          source
          url
          fileName
          id
          status
        }
        transcript
      }
    }
  }
`
